// Stores given bookingDates and listing to sessionStorage
export const storeData = (storageKey, data) => {
  if (typeof window === 'undefined') return;
  if (!window.localStorage) return;
  const replacer = function(k, v) {
    if (v instanceof Date) {
      return { date: v.toISOString(), _serializedType: 'SerializableDate' };
    }
    return v;
  };

  const storableData = JSON.stringify(data, replacer);
  window.localStorage.setItem(storageKey, storableData);
};

// Get stored data
export const storedData = storageKey => {
  if (typeof window === 'undefined') return null;
  if (!window.localStorage) return null;
  const storedData = window.localStorage.getItem(storageKey);

  const reviver = (k, v) => {
    if (v && typeof v === 'object' && v._serializedType === 'SerializableDate') {
      // Dates are expected to be stored as:
      // { date: new Date(), _serializedType: 'SerializableDate' }
      return new Date(v.date);
    }
    return v;
  };

  const data = storedData ? JSON.parse(storedData, reviver) : null;

  return data;
};

export const clearData = storageKey => {
  if (typeof window === 'undefined') return;
  if (!window.localStorage) return;
  window.localStorage.removeItem(storageKey);
};
